var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehiclesTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.229,
    height: 18.044,
    viewBox: "0 0 21.229 18.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.491,20.86a3.184,3.184,0,0,1-6.369,0A2.123,2.123,0,0,1,3,18.737V8.123A2.123,2.123,0,0,1,5.123,6H16.8a2.122,2.122,0,0,1,2.121,2.121h3.184c2.123,0,2.123,3.074,2.123,4.246v6.369a2.123,2.123,0,0,1-2.123,2.123H21.044a3.184,3.184,0,0,1-6.369,0ZM5.123,8.123v9.553H16.8V8.123Zm13.8,2.123v4.246h3.184V10.246ZM17.86,21.921A1.061,1.061,0,1,0,16.8,20.86,1.061,1.061,0,0,0,17.86,21.921Zm-9.553,0A1.061,1.061,0,1,0,7.246,20.86,1.061,1.061,0,0,0,8.307,21.921Z",
    transform: "translate(-3 -6)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclesTruckIcon);
export default __webpack_public_path__ + "static/media/vehicles-truck-icon.6399ef94.svg";
export { ForwardRef as ReactComponent };